<br>
<div style="text-align:center">
    <img width="10%" *ngIf="_storage.getItem('company') =='1'" src="../assets/logo_emm_retina.png">
    <img width="5%" *ngIf="_storage.getItem('company') =='2'" src="../assets/diemmegi.jpg">
</div>
<br>
<button mat-raised-button color="primary" (click)="newcompany()">
    <mat-icon>fiber_new</mat-icon>
</button>
<button mat-raised-button color="primary" (click)="back()">Back
    <mat-icon>keyboard_backspace</mat-icon>
</button>
<mat-card class="example-card" style="width: 100%; background-color: rgb(153, 218, 238)">
    <mat-table *ngIf="update_web == 'false'" style="border: 1px;border-color: black;border-style: solid" [dataSource]="dataSource" style="width: 100%">
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.name}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="full_name">
            <mat-header-cell *matHeaderCellDef>Full Name</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.full_name}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="emailcertificati">
            <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.emailcertificati}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="indirizzo">
            <mat-header-cell *matHeaderCellDef>Address</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.indirizzo}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row">
                <button mat-raised-button color="warn" (click)="delete(row.id, row.status)">
                    <mat-icon *ngIf="row.status == 'active'">delete_forever</mat-icon>
                    <mat-icon style="color: green" *ngIf="row.status == 'deactive'">check</mat-icon>
                </button>
                <button mat-raised-button color="primary" (click)="update(row.name, row.full_name, row.id)">
                    <mat-icon>update</mat-icon>
                </button>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="tableColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: tableColumns"></mat-row>
    </mat-table>
    <mat-form-field style="width: 100%" *ngIf="update_web == 'true' || update_web == 'new'">
        <input style="width: 100%" matInput placeholder="name" [(ngModel)]="name_web" value="name_web">
    </mat-form-field>
    <br>
    <mat-form-field style="width: 100%" *ngIf="update_web == 'true' || update_web == 'new'">
        <input style="width: 100%" matInput placeholder="Full Name" [(ngModel)]="fullname_web" value="fullname_web">
    </mat-form-field>
    <br>
    <mat-form-field style="width: 100%" *ngIf="update_web == 'true' || update_web == 'new'">
        <input style="width: 100%" matInput placeholder="Email for certificate" [(ngModel)]="emailcertificati_web" value="emailcertificati_web">
    </mat-form-field>
    <mat-form-field style="width: 100%" *ngIf="update_web == 'true' || update_web == 'new'">
        <input style="width: 100%" matInput placeholder="Address for Signature" [(ngModel)]="address_web" value="address_web">
    </mat-form-field>
    <br>
    <button *ngIf="update_web == 'true'" mat-raised-button color="primary" (click)="save()">
            <mat-icon>save</mat-icon>
    </button>
    <button *ngIf="update_web == 'new'" mat-raised-button color="primary" (click)="savenew()">
            <mat-icon>save</mat-icon>
    </button>
</mat-card>
